import * as ons from 'onsenui';

export const onsPlatform = ons.platform;
